export const trailsHeader = () => {
  return {
    background: "trail1Large.jpg",
    title: "Live a great story",
    subtitle: "Find your next hiking adventure",
    layout: "page",
    scroll: "trails",
    actions: [
      {
        title: "Discover trails",
        svg: "search",
        scroll: "trails",
        color: "blue",
      },
      {
        title: "Share a trail",
        svg: "share2",
        link: "Contribute",
        color: "white",
      },
    ],
  };
};

export const dataTable = (trail) => {
  return [
    {
      attr: "trail",
      svg: "trail",
      content: [
        {
          attr: "name",
          svg: "trail-sign",
          label: "Trail name",
          value: trail.name,
        },
        {
          attr: "name",
          svg: "starting",
          label: "Departure",
          value: trail.startLocation.name,
        },
        {
          attr: "name",
          svg: "finish",
          label: "Arrival",
          value: trail.endLocation.name,
        },
      ],
    },
    {
      attr: "position",
      svg: "localisation",
      content: [
        {
          attr: "continent",
          svg: "world",
          label: "Continent",
          value: trail.countries[0].name_continent,
        },
        {
          attr: "country",
          svg: "flag",
          label: "Country",
          value: trail.countries[0].name,
        },
        {
          attr: "region",
          svg: "region",
          label: "Region",
          value: trail.coverLocation,
        },
      ],
    },

    {
      attr: "info",
      svg: "infos",
      content: [
        {
          attr: "distance",
          svg: "hiker",
          label: "distance",
          value: trail.distance,
          unit: "km",
        },
        {
          attr: "duration",
          svg: "duration",
          label: "duration",
          value: trail.distance.toFixed(0),
          unit: "km",
        },
        {
          attr: "gain",
          svg: "elevation-gain",
          label: "gain",
          value: trail.data.gain.toFixed(0),
          unit: "m",
        },
        {
          attr: "highest-peak",
          svg: "summit",
          label: "highest peak",
          value: trail.data.maxElevation.toFixed(0),
          unit: "m",
        },
        {
          attr: "lowest-point",
          svg: "lowest",
          label: "Lowest point",
          value: trail.data.minElevation.toFixed(0),
          unit: "m",
        },
      ],
    },
    {
      attr: "more",
      svg: "three-dots",
      content: [
        // {
        //   attr: "guide",
        //   svg: "guide-1",
        //   label: "Guide",
        //   value: "Not necessary",
        // },
        // {
        //   attr: "permit",
        //   svg: "permit",
        //   label: "Permit",
        //   value: "No",
        // },
        // {
        //   attr: "association",
        //   svg: "association",
        //   label: "association",
        //   value: "No",
        // },
        // {
        //   attr: "markup",
        //   svg: "trail-name",
        //   label: "markup",
        //   value: "No",
        // },
      ],
    },
  ];
};

export const dataMap = (trail) => {
  return [
    {
      attr: "departure",
      action: "map",
      svg: "starting",
      title: "Departure",
      subtitle: trail.startLocation.name,
    },
    {
      attr: "end",
      action: "map",
      svg: "finish",
      title: "Finish",
      subtitle: trail.endLocation.name,
    },
    {
      attr: "trail",
      svg: "trail",
      title: "Trail Name",
      subtitle: trail.name,
    },
    {
      attr: "marker",
      action: "",
      img: "files/img/marker/...",
      title: "Marker",
      subtitle: trail.marker,
    },
  ];
};

export const sortOptions = () => {
  return [
    {
      val: "distanceFrom",
      name: "Distance - to +",
    },
    {
      val: "location",
      name: "country",
    },
    {
      val: "name",
      name: "name",
    },
    {
      val: "distance",
      name: "Trail length - to +",
    },
    {
      val: "-distance",
      name: "Trail length + to -",
    },
    {
      val: "duration",
      name: "Hiking days - to +",
    },
    {
      val: "-duration",
      name: "Hiking days + to -",
    },
    {
      val: "-countLikes",
      name: "popularity + to -",
    },
    {
      val: "likes",
      name: "popularity - to +",
    },
    {
      val: "-createdAt",
      name: "Latest to oldest",
    },
    {
      val: "createdAt",
      name: "Oldest to latest",
    },
  ];
};

export const dataCategories = [
  // {
  //   attribut: "trail",
  //   title: "trail",
  //   svg: "trail",
  //   type: "text",
  //   end: "",
  //   input: "no",
  // },
  // {
  //   attribut: "location",
  //   title: "location",
  //   svg: "localisation",
  //   type: "text",
  //   end: "",
  //   input: "no",
  // },
  // {
  //   attribut: "info",
  //   title: "info",
  //   svg: "infos",
  //   type: "text",
  //   end: "",
  //   input: "no",
  // },
  // {
  //   attribut: "more",
  //   title: "more",
  //   svg: "three-dots",
  //   type: "text",
  //   end: "",
  //   input: "no",
  // },
  // {
  //   attribut: "name",
  //   title: "trail name",
  //   svg: "trail-sign",
  //   table: "trail",
  //   column: "name",
  //   type: "text",
  //   end: "",
  //   input: "text",
  //   options: {
  //     type: "string",
  //     unit: "",
  //   },
  // },
  {
    attribut: "departure",
    title: "departure",
    svg: "starting",
    table: "trail_route",
    column: "departure",
    type: "text",
    end: "",
    input: "text",
    options: {
      type: "string",
      unit: "",
    },
  },
  {
    attribut: "arrival",
    title: "arrival",
    svg: "finish",
    type: "text",
    table: "trail_route",
    column: "arrival",
    end: "",
    input: "text",
    options: {
      type: "string",
      unit: "",
    },
  },
  {
    attribut: "difficulty",
    title: "difficulty",
    svg: "boot",
    table: "trail_difficulty",
    column: "cote",
    type: "text",
    end: "/5",
    input: "no",
    options: {
      message: "You can set the difficulty in the trail survey section",
      max_note: 5,
      svg: "boot",
      comments: [
        "Not defined",
        "easy",
        "accessible",
        "challenging",
        "hard",
        "expert",
      ],
      unit: "",
    },
  },
  {
    attribut: "continent",
    title: "continent",
    svg: "world",
    table: "none",
    column: "none",
    type: "text",
    end: "",
    input: "no",
    options: {
      message:
        "You need to change the country in order to change the continent",
      unit: "",
    },
  },
  {
    attribut: "country",
    title: "country",
    svg: "flag",
    table: "trail",
    column: "country",
    type: "text",
    end: "",
    input: "select",
    options: {
      type: "country",
      unit: "",
    },
  },
  {
    attribut: "region",
    title: "region",
    svg: "region",
    table: "trail",
    column: "location",
    type: "text",
    end: "",
    input: "text",
    options: {
      type: "string",
      unit: "",
    },
  },
  {
    attribut: "distance",
    title: "distance",
    svg: "hiker",
    table: "trail_basics",
    column: "length",
    type: "text",
    end: " km",
    input: "text",
    options: {
      type: "int",
      unit: "km",
      unit: "kilometers",
    },
  },
  {
    attribut: "elevation",
    title: "elevation gain",
    svg: "elevation-gain",
    table: "trail_data",
    column: "elevation",
    type: "number",
    end: " m",
    input: "text",
    options: {
      type: "int",
      unit: "meters",
    },
  },
  {
    attribut: "duration",
    title: "duration",
    svg: "duration",
    table: "trail_basics",
    column: "days",
    type: "text",
    end: " days",
    input: "text",
    options: {
      type: "int",
      unit: "days",
    },
  },
  {
    attribut: "summit",
    title: "highest peak",
    svg: "summit",
    table: "trail_data",
    column: "summit",
    type: "number",
    end: " m",
    input: "text",
    options: {
      type: "int",
      unit: "meters",
    },
  },
  {
    attribut: "lowest",
    title: "lowest point",
    svg: "lowest",
    table: "trail_data",
    column: "lowest",
    type: "number",
    end: " m",
    input: "text",
    options: {
      type: "int",
      unit: "meters",
    },
  },
  {
    attribut: "guide",
    title: "guide",
    svg: "guide",
    table: "trail_more",
    column: "id_guide_option",
    type: "text",
    end: "",
    input: "radio",
    options: {
      radio: [
        {
          id: 1,
          name: "Compulsory",
        },
        {
          id: 2,
          name: "Advised",
        },
        {
          id: 3,
          name: "Advised for beginners",
        },
        {
          id: 4,
          name: "Not necessary",
        },
      ],
      unit: "",
    },
  },
  {
    attribut: "permit",
    title: "permit",
    svg: "permit",
    table: "trail_more",
    column: "permit",
    type: "text",
    end: "",
    input: "radio",
    options: {
      radio: [
        {
          id: 1,
          name: "Yes",
        },
        {
          id: 2,
          name: "No",
        },
      ],
      type: "string",
      unit: "",
    },
  },
  {
    attribut: "popularity",
    title: "popularity",
    svg: "popularity",
    table: "trail_more",
    column: "popularity",
    type: "text",
    end: "",
    input: "radio",
    options: {
      radio: [
        {
          id: 1,
          name: "nobody",
        },
        {
          id: 2,
          name: "low",
        },
        {
          id: 3,
          name: "normal",
        },
        {
          id: 4,
          name: "high",
        },
        {
          id: 5,
          name: "crowded",
        },
      ],
      unit: "",
      max_note: 5,
      svg: "hiker",
      comments: ["Not defined", "Nobody", "Low", "Normal", "High", "Crowded"],
    },
  },
  {
    attribut: "association",
    title: "Association",
    svg: "association",
    table: "trail_more",
    column: "association",
    type: "text",
    end: "",
    input: "text",
    options: {
      type: "string",
      unit: "",
    },
  },
  {
    attribut: "markup",
    title: "Markup",
    svg: "trail-name",
    table: "trail_more",
    column: "markup",
    type: "text",
    end: "",
    input: "radio",
    options: {
      radio: [
        {
          id: 1,
          name: "Yes",
        },
        {
          id: 2,
          name: "No",
        },
      ],
      type: "string",
      unit: "",
    },
  },
];
